import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";

const TechnicalCertficateAccordion = ({
  technicalExpBlock = [],
  updateTechnicalExpBlock,
  onDeleteTechExpBlock,
  settechnicalExpIndex,
}) => {
  const { t } = useTranslation();

  return (
    <div className="accordion-item bg-transparent border-0">
      {/* ------ toggle accordion button start ------ */}
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseFive"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseFive"
        >
          {t("Certificate")}
        </button>
      </h3>
      {/* ------ toggle accordion button end ------ */}
      {/* ----- experience block list section start ----- */}
      <div
        id="panelsStayOpen-collapseFive"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          <div className="fields-group">
            <div className="fields d-flex flex-column gap-3">
              {/* ------ experience list section start ------ */}
              {technicalExpBlock.map((techExpData, index) => {
                return (
                  <div className="field" key={index}>
                    <div className="form-group">
                      <div className="row">
                        {/* ----- course section start ----- */}
                        <div className="col-lg-2 mb-3 mb-lg-0">
                          <div className="field-container d-flex align-items-center px-3 body-bg rounded-10">
                            <label
                              htmlFor="degree"
                              className="text-nowrap me-3"
                            >
                              {t("Course")}
                            </label>
                            <p className="form-control border-0 shadow-none">
                              {techExpData.name}
                            </p>
                          </div>
                        </div>
                        {/* ----- course section end ----- */}
                        {/* ----- company section start ----- */}
                        <div className="col-lg-3 mb-3 mb-lg-0">
                          <div className="field-container d-flex align-items-center px-3 body-bg rounded-10">
                            <label
                              htmlFor="degree"
                              className="text-nowrap me-3"
                            >
                              {t("Company")}
                            </label>
                            <p className="form-control border-0 shadow-none">
                              {techExpData.companyname}
                            </p>
                          </div>
                        </div>
                        {/* ----- company section end ----- */}
                        {/* ----- start date section start ----- */}
                        <div className="col-lg-3 mb-3 mb-lg-0">
                          <div className="field-container d-flex align-items-center px-3 body-bg rounded-10">
                            <label
                              htmlFor="degree"
                              className="text-nowrap me-3"
                            >
                              {t("From")}
                            </label>
                            <p className="form-control border-0 shadow-none">
                              {getDateFormatInSpanish(techExpData.start)}
                            </p>
                          </div>
                        </div>
                        {/* ----- start date section end ----- */}
                        {/* ----- end date section start ----- */}
                        <div className="col-lg-3">
                          <div className="field-container d-flex align-items-center px-3 body-bg rounded-10">
                            <label
                              htmlFor="degree"
                              className="text-nowrap me-3"
                            >
                              {t("To")}
                            </label>
                            <p className="form-control border-0 shadow-none">
                              {getDateFormatInSpanish(techExpData.end)}
                            </p>
                          </div>
                        </div>
                        {/* ----- end date section end ----- */}
                        {/* ------ edit and delete icon section start ------ */}
                        <div className="col action d-flex align-items-center justify-content-end gap-3 mb-3">
                          {/* ------ edit icon start ------ */}
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#addCertificateModal"
                            onClick={() => {
                              updateTechnicalExpBlock(techExpData, index);
                            }}
                          >
                            <span className="d-block material-symbols-outlined">
                              edit
                            </span>
                          </Link>
                          {/* ------ edit icon end ------ */}
                          {/* ------ delete icon start ------ */}
                          <Link
                            to="#"
                            onClick={() => {
                              onDeleteTechExpBlock(index);
                            }}
                          >
                            <span className="d-block material-symbols-outlined">
                              delete
                            </span>
                          </Link>
                          {/* ------ delete icon end ------ */}
                        </div>
                        {/* ------ edit and delete icon section end ------ */}
                      </div>
                    </div>
                  </div>
                );
              })}
              {/* ------ experience list section end ------ */}
            </div>
            {/* ------ add experience modal button start ------ */}
            <Link
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#addCertificateModal"
              onClick={() => {
                settechnicalExpIndex(null);
              }}
              className="btn btn-outline-primary d-inline-flex align-items-center gap-1 mt-3"
            >
              <span className="d-block material-symbols-outlined">add</span>
              <span className="d-block">{t("Add Certificate")}</span>
            </Link>
            {/* ------ add experience modal button end ------ */}
          </div>
        </div>
      </div>
      {/* ----- experience block list section end ----- */}
    </div>
  );
};

export default TechnicalCertficateAccordion;
